import { apiCMSWithToken } from './axios'

export const url = {
  breaking: `/search/qrpost`
}

export async function breakingSearch(filters = {}) {
  try {
    
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${url.breaking}?${params}`
    )
    return response
  } catch (error) {
    console.error('Error in requestSearch:', error)
    throw error
  }
}
export default {
  breakingSearch,
}
